var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.47,
    height: 23.5,
    viewBox: "0 0 23.47 23.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #3fcaea;\r\n        fill-rule: evenodd;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "linkedin.svg",
    className: "cls-1",
    d: "M1311.41,8946.99h4.87v15.69h-4.87v-15.69Zm2.44-7.79a2.825,2.825,0,1,1-2.83,2.82,2.823,2.823,0,0,1,2.83-2.82m5.49,7.79H1324v2.15h0.07a5.092,5.092,0,0,1,4.6-2.54c4.93,0,5.84,3.25,5.84,7.48v8.6h-4.87v-7.63c0-1.82-.03-4.16-2.52-4.16-2.54,0-2.92,1.98-2.92,4.03v7.76h-4.86v-15.69Z",
    transform: "translate(-1311.03 -8939.19)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.64ddd5f8eee0467faacd52e23e3e1448.svg";
export { ForwardRef as ReactComponent };